// GoogleMapsProvider.js
import React, { createContext, useContext, useMemo } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { API_KEY_MAPS } from '@shared/conf/env';

const GoogleMapsContext = createContext({
  isLoaded: false,
  loadError: null,
});

// Referencia estable: debe vivir fuera del componente para que
// useJsApiLoader no detecte un array "nuevo" en cada render.
const GOOGLE_MAPS_LIBRARIES = ['maps', 'marker'];

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: API_KEY_MAPS,
    id: 'google-map-script', // 🔥 clave: único en toda la app
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  // 🧠 evita re-renders innecesarios
  const value = useMemo(() => ({ isLoaded, loadError }), [isLoaded, loadError]);

  return (
    <GoogleMapsContext.Provider value={value}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
